// components/SkeletonCard.jsx
import React from 'react';

const SkeletonCard = () => {
  return (
    <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-200">
      {/* Image skeleton avec effet doré scintillant */}
      <div className="relative aspect-square bg-gradient-to-r from-yellow-10 via-yellow-50 to-yellow-100 bg-[length:200%_100%] animate-shimmer overflow-hidden">
        {/* Effet de brillance doré */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-100/40 to-transparent animate-shimmer"></div>
        
        {/* Petit icône doré */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-yellow-200/40 flex items-center justify-center backdrop-blur-sm">
            <svg className="w-7 h-7 text-yellow-500/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
        </div>
        
        {/* Petit motif de points dorés */}
        <div className="absolute bottom-2 right-2 flex gap-1">
          <div className="w-1 h-1 rounded-full bg-yellow-300/60"></div>
          <div className="w-1 h-1 rounded-full bg-yellow-300/60"></div>
          <div className="w-1 h-1 rounded-full bg-yellow-300/60"></div>
        </div>
      </div>
      
      {/* Contenu - entièrement en gris avec animation subtile */}
      <div className="p-4 space-y-3">
        {/* Titre */}
        <div className="h-3 bg-gray-100 rounded-lg w-3/4 animate-shimmer-subtle"></div>
        
        {/* Catégorie */}
        {/* <div className="h-4 bg-gray-100 rounded-lg w-1/2 animate-shimmer-subtle"></div> */}
        
        {/* Prix */}
        {/* <div className="h-6 bg-gray-200 rounded-lg w-2/3 animate-shimmer-subtle"></div> */}
        
        {/* Stock */}
        <div className="h-3 bg-gray-100 rounded-lg w-1/3 animate-shimmer-subtle"></div>
        
        {/* Bouton */}
        <div className="h-4 bg-gray-100 rounded-xl w-full relative overflow-hidden animate-shimmer-subtle">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-200/50 to-transparent animate-shimmer-subtle"></div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;